import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';
import BaseAPI from '../../api/apiurl';


const ApexChartPStaffM = () => {
  const [chartData, setChartData] = useState({
    labels: ["Awaiting", "Planned", "Completed", "In-Audit", "Cancelled", "Unknown"],
    series: [0, 0, 0, 0, 0, 0],
    chartOptions: {
      type: 'donut',
    },
  });

  useEffect(() => {
    // Fetch data from the API
    const fetchData = async () => {
      try {
        const companyId = localStorage.getItem('companyid');
        const customerId = localStorage.getItem('customerid');

        const apiUrl = `${BaseAPI}projecttaskcount?company_id=${companyId}&customer_id=${customerId}`;
        const response = await fetch(apiUrl);
        const data = await response.json();

        if (data.status === 200) {
          // Update the state with the fetched data
          setChartData({
            labels: Object.keys(data.data[0]),
            series: Object.values(data.data[0]),
            chartOptions: {
              type: 'donut',
            },
          });
        } else {
          console.error('Error fetching data:', data.status);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData(); // Call the fetchData function when the component mounts
  }, []); // The empty dependency array ensures that this effect runs once after the initial render

  return (
    <Chart
      options={{
        labels: chartData.labels,
        ...chartData.chartOptions,
      }}
      series={chartData.series}
      type="donut"
      height={300}
    />
  );
};

export default ApexChartPStaffM;
